module.exports = __webpack_public_path__ + "img/UD-sp-logo.cd391db0.png";